function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var UnsupportedLayerReason = /*#__PURE__*/function () {
  function UnsupportedLayerReason(id, severity) {
    _classCallCheck(this, UnsupportedLayerReason);
    this._id = id || 'default';
    this._severity = severity || UnsupportedLayerReason.WARNING;
  }
  return _createClass(UnsupportedLayerReason, [{
    key: "setId",
    value: function setId(id) {
      this._id = id;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "setSeverity",
    value: function setSeverity(level) {
      this._severity = level;
    }
  }, {
    key: "getSeverity",
    value: function getSeverity() {
      return this._severity;
    }
  }, {
    key: "setDescription",
    value: function setDescription(desc) {
      this._description = desc;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this._description || Oskari.getMsg('MapModule', 'layerUnsupported.common');
    }
  }, {
    key: "setAction",
    value: function setAction(action) {
      this._action = action;
    }
  }, {
    key: "getAction",
    value: function getAction() {
      return this._action;
    }
  }, {
    key: "setActionText",
    value: function setActionText(text) {
      this._actionText = text;
    }
  }, {
    key: "getActionText",
    value: function getActionText() {
      return this._actionText;
    }
  }, {
    key: "setLayerCheckFunction",
    value: function setLayerCheckFunction(check) {
      this._layerCheck = check;
    }

    /**
     * @method isLayerSupported     *
     * For checking wether layer is supported in current map view or not.
     * @return function that receives layer as param and should return boolean or `UnsupportedLayerReason` if layer is not supported.
     */
  }, {
    key: "getLayerCheckFunction",
    value: function getLayerCheckFunction() {
      return typeof this._layerCheck === 'function' ? this._layerCheck : function () {
        return true;
      };
    }
  }]);
}();

// Severity levels
UnsupportedLayerReason.INFO = 10;
UnsupportedLayerReason.WARNING = 100;
UnsupportedLayerReason.FATAL = 1000;
Oskari.clazz.defineES('Oskari.mapframework.domain.UnsupportedLayerReason', UnsupportedLayerReason);